import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

import { TAppDispatch, TRootState } from "../../../app/providers/redux/store"

export const useTypedSelector: TypedUseSelectorHook<TRootState> = useSelector
export const useAppDispatch = () => useDispatch<TAppDispatch>()
